<div
  class="gigantes-bg-layout"
  [style.--gigantes-bg-image]="'url(' + bgUrl + ')'"
>
  <app-header mode="transparent"></app-header>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>
